/* Etichette generate da Shopify nella lingua del negozio: tradotte in italiano */
(function () {
  const SORT = {
    manual: 'In primo piano',
    relevance: 'Più rilevanti',
    'best-selling': 'Best seller',
    'title-ascending': 'In ordine alfabetico, A-Z',
    'title-descending': 'In ordine alfabetico, Z-A',
    'price-ascending': 'Prezzo crescente',
    'price-descending': 'Prezzo decrescente',
    'created-ascending': 'Data, da meno a più recente',
    'created-descending': 'Data, da più a meno recente',
  };
  const WORDS = {
    'Disponibilité': 'Disponibilità',
    'En stock': 'Disponibile',
    'Rupture de stock': 'Esaurito',
    'Épuisé': 'Esaurito',
    'Prix': 'Prezzo',
    'Couleur': 'Colore',
    'Taille': 'Taglia',
    'Type de produit': 'Tipo di prodotto',
    'Marque': 'Marca',
    'Availability': 'Disponibilità',
    'In stock': 'Disponibile',
    'Out of stock': 'Esaurito',
    'Price': 'Prezzo',
    'Color': 'Colore',
    'Colour': 'Colore',
    'Size': 'Taglia',
  };
  let busy = false;
  function run() {
    if (busy) return;
    busy = true;
    document.querySelectorAll('select[name="sort_by"] option').forEach((o) => {
      if (SORT[o.value] && o.textContent.trim() !== SORT[o.value]) o.textContent = SORT[o.value];
    });
    const roots = document.querySelectorAll('#MainContent, #CartDrawer');
    roots.forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = walker.nextNode())) {
        const raw = n.nodeValue;
        const t = raw.trim();
        if (!t || t.length > 40) continue;
        const key = t.replace(/:$/, '');
        if (WORDS[key]) n.nodeValue = raw.replace(key, WORDS[key]);
      }
    });
    busy = false;
  }
  const start = () => {
    run();
    let t;
    new MutationObserver(() => {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(run, 60);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Carrello: "Potrebbe piacerti anche" + Vista rapida */
(function () {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cache = {};
  const cur = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  let symbol = '€';
  try {
    symbol = new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur() })
      .formatToParts(0)
      .find((p) => p.type === 'currency').value;
  } catch (e) {}
  const money = (cents) => symbol + (cents / 100).toFixed(2).replace('.', ',');
  const toCents = (v) => (typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v || 0);
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (src, w) => {
    if (!src) return '';
    const u = src.startsWith('//') ? 'https:' + src : src;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + w;
  };

  function norm(p) {
    const v = (p.variants && p.variants[0]) || {};
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: p.url || root() + 'products/' + p.handle,
      image: p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
      price: toCents(p.price !== undefined ? p.price : v.price),
      compare: toCents(p.compare_at_price !== undefined ? p.compare_at_price : v.compare_at_price),
    };
  }

  async function getProducts(ids) {
    const key = ids.join(',');
    if (cache[key]) return cache[key];
    let list = [];
    try {
      const r = await fetch(root() + 'recommendations/products.json?product_id=' + ids[0] + '&limit=8');
      if (r.ok) list = ((await r.json()).products || []).map(norm);
    } catch (e) {}
    if (list.length < 2) {
      try {
        const r = await fetch(root() + 'collections/all/products.json?limit=12');
        if (r.ok) list = list.concat(((await r.json()).products || []).map(norm));
      } catch (e) {}
    }
    const seen = new Set(ids.map(String));
    list = list.filter((p) => !seen.has(String(p.id)) && seen.add(String(p.id))).slice(0, 4);
    cache[key] = list;
    return list;
  }

  async function renderUpsell() {
    const box = document.querySelector('#CartDrawer [data-sm-upsell]');
    if (!box || box.dataset.done) return;
    box.dataset.done = '1';
    const ids = (box.dataset.ids || '').split(',').filter(Boolean);
    if (!ids.length) return;
    const list = await getProducts(ids);
    if (!list.length) return;
    box.querySelector('[data-sm-upsell-track]').innerHTML = list
      .map(
        (p) => `
      <div class="sm-upsell__card">
        <a class="sm-upsell__media" href="${esc(p.url)}">${p.image ? `<img src="${esc(img(p.image, 200))}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
        <div class="sm-upsell__info">
          <a class="sm-upsell__name" href="${esc(p.url)}">${esc(p.title)}</a>
          <p class="sm-upsell__price"><span class="sm-upsell__sale">${money(p.price)}</span>${p.compare > p.price ? ` <s>${money(p.compare)}</s>` : ''}</p>
          <button type="button" class="sm-upsell__btn" data-sm-quick="${esc(p.handle)}">Vista rapida</button>
        </div>
      </div>`
      )
      .join('');
    box.hidden = false;
  }

  /* Vista rapida */
  let dlg;
  function dialog() {
    if (dlg) return dlg;
    dlg = document.createElement('div');
    dlg.className = 'sm-quick';
    dlg.hidden = true;
    dlg.innerHTML = '<div class="sm-quick__overlay" data-sm-close></div><div class="sm-quick__box" role="dialog" aria-modal="true" aria-label="Vista rapida"><button type="button" class="sm-quick__close" data-sm-close aria-label="Chiudi">&times;</button><div class="sm-quick__body"></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-sm-close]')) closeQuick();
    });
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && !dlg.hidden) closeQuick();
    });
    return dlg;
  }
  function closeQuick() {
    if (dlg) dlg.hidden = true;
  }

  async function openQuick(handle) {
    const d = dialog();
    const body = d.querySelector('.sm-quick__body');
    body.innerHTML = '<p class="sm-quick__loading">Caricamento in corso...</p>';
    d.hidden = false;
    let p;
    try {
      p = await (await fetch(root() + 'products/' + handle + '.js')).json();
    } catch (e) {
      body.innerHTML = '<p>Si è verificato un errore. Riprova.</p>';
      return;
    }
    const sel = (p.variants.find((v) => v.available) || p.variants[0]).options.slice();
    const opts = (p.options || []).filter((o) => !(p.variants.length === 1 && o.values && o.values.length === 1 && /default/i.test(o.values[0])));
    const current = () => p.variants.find((v) => v.options.every((x, i) => x === sel[i]));
    const draw = () => {
      const v = current();
      const price = v ? v.price : p.price;
      const cmp = v ? v.compare_at_price : p.compare_at_price;
      const pct = cmp > price ? Math.round(((cmp - price) / cmp) * 100) : 0;
      const image = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      body.innerHTML = `
        <div class="sm-quick__grid">
          <div class="sm-quick__media">${pct ? `<span class="sm-card__badge">-${pct}%</span>` : ''}${image ? `<img src="${esc(img(image, 700))}" alt="${esc(p.title)}">` : ''}</div>
          <div class="sm-quick__info">
            <p class="sm-quick__title">${esc(p.title)}</p>
            <p class="sm-quick__price"><span class="sm-upsell__sale">${money(price)}</span>${cmp > price ? ` <s>${money(cmp)}</s>` : ''}</p>
            ${opts
              .map(
                (o, i) => `
              <div class="sm-quick__opt">
                <p class="sm-quick__label">${esc(o.name)}: <strong>${esc(sel[i])}</strong></p>
                <div class="sm-quick__vals">${o.values
                  .map((val) => `<button type="button" class="sm-quick__val${val === sel[i] ? ' is-active' : ''}" data-i="${i}" data-v="${esc(val)}">${esc(val)}</button>`)
                  .join('')}</div>
              </div>`
              )
              .join('')}
            <button type="button" class="button sm-quick__add" ${v && v.available ? '' : 'disabled'}>${v && v.available ? 'Aggiungi al carrello' : 'Esaurito'}</button>
            <a class="sm-quick__more" href="${esc(p.url || root() + 'products/' + p.handle)}">Visualizza dettagli completi</a>
          </div>
        </div>`;
      body.querySelectorAll('.sm-quick__val').forEach((b) =>
        b.addEventListener('click', () => {
          sel[+b.dataset.i] = b.dataset.v;
          draw();
        })
      );
      const add = body.querySelector('.sm-quick__add');
      add.addEventListener('click', async () => {
        const vv = current();
        if (!vv) return;
        add.disabled = true;
        add.textContent = 'Caricamento in corso...';
        try {
          const res = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: vv.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
          });
          const data = await res.json();
          closeQuick();
          const drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections && typeof drawer.renderContents === 'function') {
            data.id = vv.id;
            drawer.renderContents(data);
          } else {
            location.href = root() + 'cart';
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sm-quick', productVariantId: vv.id });
          }
        } catch (e) {
          add.disabled = false;
          add.textContent = 'Aggiungi al carrello';
        }
      });
    };
    draw();
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sm-quick]');
    if (!b) return;
    e.preventDefault();
    openQuick(b.dataset.smQuick);
  });

  const startUpsell = () => {
    renderUpsell();
    const el = document.getElementById('CartDrawer');
    if (!el) return;
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(renderUpsell, 50);
    }).observe(el, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startUpsell);
  else startUpsell();
})();